import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getItems, searchItems } from '../services/api';
import { Box, Search, Barcode } from 'lucide-react';

const ItemList = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      const response = await getItems();
      setItems(response.data);
    } catch (error) {
      console.error('Error fetching items:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchQuery.trim()) {
      fetchItems();
      return;
    }
    
    try {
      setLoading(true);
      const response = await searchItems(searchQuery);
      setItems(response.data);
    } catch (error) {
      console.error('Error searching items:', error);
    } finally {
      setLoading(false);
    }
  };

  const clearSearch = () => {
    setSearchQuery('');
    fetchItems();
  };

  if (loading) return <div className="container">Loading...</div>;

  return (
    <div className="container">
      <h1>All Items</h1>

      <div className="card" style={{ marginTop: '20px' }}>
        <form onSubmit={handleSearch} style={{ display: 'flex', gap: '10px' }}>
          <input
            type="text"
            className="input"
            placeholder="Search items by name, description, or barcode..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ marginBottom: 0 }}
          />
          <button type="submit" className="button" style={{ whiteSpace: 'nowrap' }}>
            <Search size={20} style={{ display: 'inline', marginRight: '5px' }} />
            Search
          </button>
          {searchQuery && (
            <button type="button" onClick={clearSearch} className="button button-secondary">
              Clear
            </button>
          )}
        </form>
      </div>

      <div className="grid" style={{ marginTop: '20px' }}>
        {items.map((item) => (
          <div
            key={item.id}
            className="list-item"
            onClick={() => navigate(`/items/${item.id}`)}
          >
            <h3>
              <Box size={20} style={{ display: 'inline', marginRight: '8px' }} />
              {item.name}
            </h3>
            {item.barcode && (
              <p style={{ fontSize: '12px', color: '#007bff', marginTop: '5px', display: 'flex', alignItems: 'center' }}>
                <Barcode size={16} style={{ marginRight: '5px' }} />
                {item.barcode}
              </p>
            )}
            <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
              <p>Quantity: {item.quantity}</p>
            </div>
          </div>
        ))}
      </div>

      {items.length === 0 && (
        <div className="card" style={{ textAlign: 'center', color: '#666', marginTop: '20px' }}>
          <p>{searchQuery ? 'No items found matching your search.' : 'No items yet.'}</p>
        </div>
      )}
    </div>
  );
};

export default ItemList;
